import React from 'react';

function StatCard({ icon = '[]', label, value, sublabel }) {
  return (
    <article className="rounded-xl border border-gray-700 bg-gray-900/70 p-4">
      <div className="flex items-start justify-between gap-3">
        <div>
          <p className="text-xs uppercase tracking-wide text-gray-400">{label}</p>
          <p className="mt-2 text-2xl font-bold text-gray-100">{value}</p>
          {sublabel && <p className="mt-1 text-xs text-gray-500">{sublabel}</p>}
        </div>
        <span className="inline-flex h-8 w-8 items-center justify-center rounded-md bg-axial-600/20 text-xs font-bold text-axial-300">
          {icon}
        </span>
      </div>
    </article>
  );
}

export default StatCard;
